export default {
  id: "page8",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      number: "22",
      label:
        "Jak często jada Pan(i) następujące rodzaje <span class='has-text-danger'>deserów z torebki</span>?",
      info:
        "Dla każdego deseru (w wierszu) proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością.<br><br><strong><span class='has-text-danger'>UWAGA - INNA CZĘSTOTLIWOŚĆ NIŻ W PYT. 21</span></strong>"
    },
    {
      type: "choice_names",
      options: [
        "Raz w tygodniu lub częściej",
        "1-2 razy w miesiącu",
        "Raz na 2-3 miesiące",
        "Rzadziej",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      type: "justlabel",
      label: "Desery na kilka porcji"
    },
    {
      label: "Budyń do gotowania na mleku",
      type: "radio",
      id: "kategoria4_budynPorcje",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Kisiel do gotowania",
      type: "radio",
      id: "kategoria4_kisielGotowany",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Galaretka",
      type: "radio",
      id: "kategoria4_galaretka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label:
        "Inne desery z torebki typu tiramisu, panna cotta, mus czekoladowy itp.",
      type: "radio",
      id: "kategoria4_deseryRozne",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      type: "justlabel",
      label: "Desery jednoporcjowe, zalewane wrzątkiem"
    },
    {
      label: "Budyń",
      type: "radio",
      id: "kategoria4_budynJednaP",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Kisiel bez kawałków owoców",
      type: "radio",
      id: "kategoria4_kisielJednaP",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Kisiel z kawałkami owoców",
      type: "radio",
      id: "kategoria4_kisielOwoce",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Kaszka manna",
      type: "radio",
      id: "kategoria4_kaszka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Mleczny ryż",
      type: "radio",
      id: "kategoria4_ryz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    },
    {
      label: "Owsianka",
      type: "radio",
      id: "kategoria4_owsianka",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page8.js